import { Outlet, useNavigation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import './AppLayout.css';
import NotificationBell from '@/components/notifications/NotificationBell';
import { useAccessControl } from '@/contexts/AccessContext';
import { useRoleRouteSync } from '@/hooks/useRoleRouteSync';

const AppLayout = () => {
  const { activeRoleCode } = useAccessControl();
  const canRenderRoute = useRoleRouteSync();
  // Route pages are lazy-loaded (see App.routes.tsx); the router keeps the current page
  // mounted until the next one's chunk + loader are ready, so this is the only feedback
  // a slower chunk fetch gets — without it, clicking a nav link would look like nothing
  // happened until the download finishes.
  const navigation = useNavigation();

  return (
    <div className="flex items-start min-h-screen app-shell">
      {navigation.state !== 'idle' && (
        <div className="fixed inset-x-0 top-0 z-100 h-0.5 animate-pulse bg-[var(--m4-purple-700)]" />
      )}
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col h-screen overflow-hidden">
        <header className="sticky top-0 z-40 flex h-16 shrink-0 items-center justify-end gap-4 px-8 bg-white border-b">
          <NotificationBell />
        </header>
        <div className="flex-1 flex flex-col overflow-y-auto relative">
          {canRenderRoute && <Outlet key={activeRoleCode ?? 'default'} />}
        </div>
      </main>
    </div>
  );
};
export default AppLayout;
